/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import Promise from 'bluebird';
import _ from 'underscore';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { ModelLoader } from 'app/scripts/db/model-loader';
import { Util } from 'app/scripts/lib/util';
import { AttachmentTypePickerView } from 'app/scripts/views/card/AttachmentTypePickerView';
import { AutoMentionerView } from 'app/scripts/views/internal/autocomplete/AutoMentionerView';
import { EmojiCompleterView } from 'app/scripts/views/internal/autocomplete/EmojiCompleterView';
import { TrelloCompleterView } from 'app/scripts/views/internal/autocomplete/TrelloCompleterView';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const membersLastLoaded = {};

// eslint-disable-next-line @trello/enforce-variable-case
const CompleterUtil = {
  // @ts-expect-error TS(7023): 'openEmojiCompleter' implicitly has return type 'a... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openEmojiCompleter(e: any) {
    stopPropagationAndPreventDefault(e);

    return PopOver.pushView({
      view: this.getEmojiCompleterView('button'),
    });
  },

  // @ts-expect-error TS(7023): 'autoMentionerView' implicitly has return type 'an... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  autoMentionerView(source: any, card: any, board: any) {
    const model = card != null ? card : board;
    return new AutoMentionerView({
      model,
      button: source === 'button',
      input: source === 'input',
      // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
      target: this.getTextInput(),
      card,
      board,
    });
  },

  // @ts-expect-error TS(7023): 'getAutoMentionerView' implicitly has return type ... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getAutoMentionerView(source: any) {
    // Define source models for both card-detail and description views
    let org;
    // @ts-expect-error TS(7022): 'card' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    const card = this.getCard != null ? this.getCard() : this.card;
    // @ts-expect-error TS(7022): 'board' implicitly has type 'any' because it does ... Remove this comment to see the full error message
    const board = card ? card.getBoard() : this.board;

    // Load the org members if we haven't done that recently
    if ((org = board != null ? board.getOrganization() : undefined) != null) {
      if (
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        !membersLastLoaded[org.id] ||
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        Date.now() - membersLastLoaded[org.id] > 5 * 60 * 1000
      ) {
        // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
        membersLastLoaded[org.id] = Date.now();
        ModelLoader.loadOrganizationMembersData(org.id);
      }
    }

    // Load board members if modelCache isn't properly populated
    // @ts-expect-error TS(2339): Property 'modelCache' does not exist on type '{ op... Remove this comment to see the full error message
    const memberships = this.modelCache
      .get('Board', board.id)
      .get('memberships');
    // @ts-expect-error TS(2554): Expected 2-3 arguments, but got 1.
    const idBoardMemsById = _.indexBy(board.getIdBoardMems());

    if (idBoardMemsById.length !== memberships.length) {
      // NOTE: Unfortunately this situation is also triggered by boards that
      // have a deactivated user (which due to a server bug leaves a membership
      // behind for the deleted member)  If we only have deactivated users missing
      // that's not a problem and we don't need to load all the members
      const hasUnloadedMembers = memberships.some(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (membership: any) =>
          !membership.deactivated &&
          !Object.prototype.hasOwnProperty.call(
            idBoardMemsById,
            membership.idMember,
          ),
      );

      if (hasUnloadedMembers) {
        return ModelLoader.loadBoardMembers(board.id).then(() =>
          this.autoMentionerView(source, card, board),
        );
      }
    }

    return Promise.resolve(this.autoMentionerView(source, card, board));
  },

  // @ts-expect-error TS(7023): 'getEmojiCompleterView' implicitly has return type... Remove this comment to see the full error message
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getEmojiCompleterView(source: any) {
    // Define source models for both card-detail and description views
    // @ts-expect-error TS(7022): 'card' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    const card = this.getCard != null ? this.getCard() : this.card;
    // @ts-expect-error TS(7022): 'board' implicitly has type 'any' because it does ... Remove this comment to see the full error message
    const board = card ? card.getBoard() : this.board;
    // @ts-expect-error TS(7022): 'model' implicitly has type 'any' because it does ... Remove this comment to see the full error message
    const model = card != null ? card : board;

    return new EmojiCompleterView({
      model,
      button: source === 'button',
      input: source === 'input',
      // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
      target: this.getTextInput(),
      card,
    });
  },

  getTrelloCompleterView() {
    // @ts-expect-error TS(2339): Property 'getCard' does not exist on type '{ openE... Remove this comment to see the full error message
    const card = this.getCard();

    return new TrelloCompleterView({
      model: card,
      button: true,
      // @ts-expect-error TS(2339): Property 'getTextInput' does not exist on type '{ ... Remove this comment to see the full error message
      target: this.getTextInput(),
      card,
    });
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentAddAttachment(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedButtonEvent({
      // @ts-expect-error TS(2322): Type '"commentAddAttachmentButton"' is not assigna... Remove this comment to see the full error message
      buttonName: 'commentAddAttachmentButton',
      source: 'cardDetailScreen',
    });

    // eslint-disable-next-line @trello/enforce-variable-case
    const $textInput = $(e.target).closest('.comment-box').find('textarea');
    const selectionStart = $textInput.prop('selectionStart');
    const selectionEnd = $textInput.prop('selectionEnd');
    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    const selectedText = $textInput
      .val()
      .substring(selectionStart, selectionEnd);

    // @ts-expect-error TS(2339): Property 'getCard' does not exist on type '{ openE... Remove this comment to see the full error message
    const card = this.getCard();

    const view = new AttachmentTypePickerView({
      model: card,
      defaultName: selectedText,
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    view.on('attach', function ({ url, name }: any) {
      name = name || selectedText;

      const replacement = name ? `[${name}](${url})` : url;
      Util.insertSelection(
        $textInput,
        `${replacement} `,
        selectionStart,
        selectionEnd,
      );
      return $textInput.trigger('autosize.resize');
    });

    PopOver.toggle({
      elem: $(e.currentTarget),
      keepEdits: true,
      view,
      options: { model: card },
    });

    Analytics.sendScreenEvent({
      name: 'cardAttachmentPickerInlineDialog',
      containers: {
        card: {
          id: card.id,
        },
      },
    });
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentMentionMember(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedButtonEvent({
      // @ts-expect-error TS(2322): Type '"commentMentionMemberButton"' is not assigna... Remove this comment to see the full error message
      buttonName: 'commentMentionMemberButton',
      source: 'cardDetailScreen',
    });

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.getAutoMentionerView('button').then((view: any) =>
      PopOver.toggle({
        elem: $(e.currentTarget),
        keepEdits: true,
        view,
      }),
    );

    Analytics.sendScreenEvent({
      name: 'mentionMembersInlineDialog',
      containers: {
        card: {
          // @ts-expect-error TS(2339): Property 'getCard' does not exist on type '{ openE... Remove this comment to see the full error message
          id: this.getCard()?.id,
        },
      },
    });
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentAddEmoji(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedButtonEvent({
      // @ts-expect-error TS(2322): Type '"commentAddEmojiButton"' is not assignable t... Remove this comment to see the full error message
      buttonName: 'commentAddEmojiButton',
      source: 'cardDetailScreen',
    });

    PopOver.toggle({
      elem: $(e.currentTarget),
      keepEdits: true,
      view: this.getEmojiCompleterView('button'),
    });

    Analytics.sendScreenEvent({
      name: 'cardEmojiPickerInlineDialog',
      containers: {
        card: {
          // @ts-expect-error TS(2339): Property 'getCard' does not exist on type '{ openE... Remove this comment to see the full error message
          id: this.getCard()?.id,
        },
      },
    });
  },

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  commentAddCard(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendClickedButtonEvent({
      // @ts-expect-error TS(2820): Type '"commentAddCardButton"' is not assignable to... Remove this comment to see the full error message
      buttonName: 'commentAddCardButton',
      source: 'cardDetailScreen',
    });

    PopOver.toggle({
      elem: $(e.currentTarget),
      keepEdits: true,
      view: this.getTrelloCompleterView(),
    });

    Analytics.sendScreenEvent({
      name: 'cardTrelloCompleterInlineDialog',
      containers: {
        card: {
          // @ts-expect-error TS(2339): Property 'getCard' does not exist on type '{ openE... Remove this comment to see the full error message
          id: this.getCard()?.id,
        },
      },
    });
  },
};

export { CompleterUtil };
